import { render, staticRenderFns } from "./RankingColumnInfo.vue?vue&type=template&id=69e8853c&scoped=true"
import script from "./RankingColumnInfo.vue?vue&type=script&lang=js"
export * from "./RankingColumnInfo.vue?vue&type=script&lang=js"
import style0 from "./RankingColumnInfo.vue?vue&type=style&index=0&id=69e8853c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e8853c",
  null
  
)

export default component.exports